import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface RescheduleConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isPending: boolean;
  isGroupInterview: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function RescheduleConfirmDialog({
  open,
  onOpenChange,
  isPending,
  isGroupInterview,
  onConfirm,
  onCancel,
}: RescheduleConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reagendar entrevista</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Tem certeza que deseja reagendar esta entrevista? Isso cancelará o agendamento atual e o
          evento no Google Calendar.
        </p>
        {isGroupInterview && (
          <div className="flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 dark:border-amber-800 dark:bg-amber-950/30 p-3">
            <AlertTriangle className="w-4 h-4 text-amber-600 dark:text-amber-400 mt-0.5 shrink-0" />
            <p className="text-sm text-amber-700 dark:text-amber-300">
              Esta é uma entrevista em grupo. O reagendamento cancelará o agendamento para todos os
              entrevistadores do grupo.
            </p>
          </div>
        )}
        <div className="flex justify-end gap-2 mt-4">
          <Button variant="outline" onClick={onCancel}>
            Cancelar
          </Button>
          <Button data-testid="button-confirm-reschedule" disabled={isPending} onClick={onConfirm}>
            {isPending ? "Reagendando..." : "Reagendar"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
